import { render, staticRenderFns } from "./ArtistList.vue?vue&type=template&id=057bcc99&scoped=true"
import script from "./ArtistList.vue?vue&type=script&lang=js"
export * from "./ArtistList.vue?vue&type=script&lang=js"
import style0 from "./ArtistList.vue?vue&type=style&index=0&id=057bcc99&prod&lang=scss&scoped=true"
import style1 from "./ArtistList.vue?vue&type=style&index=1&id=057bcc99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057bcc99",
  null
  
)

export default component.exports